<!-- 
	号码展示
	lovi 2020-07-25
 -->
<template>
  <div @click="selectDateFlag = false">
    <task-timing
      v-if="taskTimingFlag"
      :selectDateFlag.sync="selectDateFlag"
      :thisDay.sync="thisDay"
      :switchFlag.sync="switchFlag"
      @getTaskTiming="getTaskTiming"
    />
    <template v-if="!comboFlag">
      <div
        class="recharge-item global-dl"
        v-for="(item, index) in numberList"
        :key="index"
      >
        <dl class="recharge-title">
          <dt>{{ $t("recharge.operator") }}：</dt>
          <dd>{{ item.name }}</dd>
        </dl>
        <dl>
          <dt>{{ $t("recharge.rechargeNumber") }}：</dt>
          <dd>
            <div class="recharge-num">
              <ul>
                <li
                  v-for="(phone, phoneIndex) in item.phones"
                  :key="phoneIndex"
                >
                  {{ _phoneFormat(phone) }}
                </li>
              </ul>
            </div>
            <div class="recharge-tab" v-if="rechargeType == 0">
              <money-list
                v-if="item.denomination.length"
                :money.sync="item.amount"
                :moneyId.sync="item.denomination_id"
                :list="item.denomination"
                :custom="item.operator_recharge"
                :rate="Number(curPay.exchange_rate)"
                :recently="item.recently"
              />
              <div v-else class="no-operator text-gray">
                {{ $t("recharge.operatorNotSupport") }}
              </div>
            </div>
            <div class="recharge-tab" v-else>
              <div
                v-if="operatorState[item.operator_id] == 1"
                @click="clickCombo(item, index)"
                class="choose-combo"
              >
                <div class="info" v-if="item.denomination_id">
                  <p>
                    {{ item.content }}
                  </p>
                  <span class="text-orange"> {{ item.amount }}P </span>
                </div>
                <div class="info default" v-else>
                  <p>{{ $t("recharge.dataChargeSelectPackage") }}</p>
                </div>
                <Icon type="ios-arrow-forward" />
              </div>
              <div v-else class="no-operator text-gray">
                {{ $t("recharge.operatorNotSupport") }}
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <!-- 选择支付方式 -->
      <pay-list
        :showDiscount="!taskTimingFlag && rechargeType == 0 ? true : false"
        :discountType="!taskTimingFlag && rechargeType == 0 ? 1 : 0"
        :type="2"
        @getCurPay="getCurPay"
      />
      <div class="button-wrap">
        <Button type="primary" long @click="nextStep">
          {{ $t("common.nextStep") }}
        </Button>
      </div>
    </template>
    <!-- 选择套餐 -->
    <combo
      v-else
      :comboFlag.sync="comboFlag"
      :operatorId.sync="operatorId"
      @getComboInfo="getComboInfo"
    />
  </div>
</template>

<script>
import TaskTiming from "@/components/recharge/taskTiming";
import MoneyList from "@/components/recharge/moneyList";
import Combo from "@/components/recharge/combo";
import PayList from "@/components/payList";
export default {
  props: {
    numberList: {
      // 展示的数组
      type: Array,
      default: function() {
        return [];
      }
    },
    rechargeType: {
      // 当前选中的tab页
      type: Number,
      default: function() {
        return 0;
      }
    },
    curPay: {
      // 当前支付方式
      type: Object,
      default: function() {
        return {};
      }
    },
    operatorState: {
      // 运营商支持流量套餐状态
      type: Object,
      default: function() {
        return {};
      }
    },
    taskTimingFlag: {
      // 设置任务时间Flag
      type: Boolean,
      default: false
    },
    taskInfo: {
      // 定时任务信息
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    TaskTiming,
    MoneyList,
    Combo,
    PayList
  },
  data() {
    return {
      selectDateFlag: false,
      thisDay: 1, //设置定时任务时的日期
      switchFlag: true, //设置定时任务时的开关
      comboFlag: false, //流量套餐弹窗
      comboInfo: {}, //套餐选择的信息
      comboIndex: 0 //当前点击套餐在总数据中的下标,获取号码用的
    };
  },
  created() {},
  mounted() {
    if (this.taskInfo.timer_id) {
      this.thisDay = this.taskInfo.day;
      this.switchFlag = this.taskInfo.state == 1 ? true : false;
    }
  },
  computed: {},
  methods: {
    getTaskTiming(data) {
      // 获取定时任务信息
      console.log("getTaskTiming", data);
      let vm = this;
      vm.thisDay = data.thisDay;
      vm.switchFlag = data.switchFlag;
    },
    getCurPay(data) {
      // 获取当前支付信息
      this.$emit("update:curPay", data);
    },
    clickCombo(data, index) {
      //选择套餐
      let vm = this;
      vm.comboIndex = index;
      vm.operatorId = data.operator_id;
      vm.comboFlag = true;
    },
    getComboInfo(data) {
      //获取套餐信息
      let vm = this;
      console.log("getComboInfo", data);
      let arr = vm.numberList;
      let obj = arr[vm.comboIndex];
      obj.denomination_id = data.denomination_id;
      obj.amount = data.amount;
      obj.content = data.content;
      vm.$set(arr, vm.comboIndex, obj);
      vm.$emit("update:numberList", arr);
      console.log("numberList", arr);
      vm.comboFlag = false;
    },
    nextStep() {
      //立即充值
      let vm = this;
      let params = {};
      let list = [];
      for (let key of vm.numberList) {
        if (
          (vm.rechargeType == 0 && key.denomination.length) ||
          (vm.rechargeType == 1 && vm.operatorState[key.operator_id] == 1)
        ) {
          let obj = {};
          obj.name = key.name;
          obj.operator_recharge = key.operator_recharge;
          obj.operator_id = key.operator_id;
          obj.denomination_id = key.denomination_id;
          obj.amount = key.amount;
          obj.content = key.content;
          obj.phones = key.phones;
          list.push(obj);
        }
      }
      if (!list.length) {
        vm.$Message.info(vm.$t("recharge.operatorNotSupport"));
        return false;
      }
      let money = 0;
      for (let key of list) {
        if (key.amount == 0) {
          if (vm.rechargeType == 1) {
            vm.$Message.info(vm.$t("recharge.pleaseSelectPackage"));
          } else {
            vm.$Message.info(vm.$t("common.enterAmount"));
          }
          return false;
        }
        if (vm.rechargeType == 0) {
          if (
            !key.denomination_id &&
            key.operator_recharge &&
            (key.operator_recharge.amount_mini ||
              key.operator_recharge.amount_max)
          ) {
            if (
              Number(key.amount) < Number(key.operator_recharge.amount_mini)
            ) {
              vm.$Message.info(
                key.name +
                  vm.$t("common.customized") +
                  vm.$t("common.amountCannotMin") +
                  key.operator_recharge.amount_mini
              );
              return;
            }
            if (Number(key.amount) > Number(key.operator_recharge.amount_max)) {
              vm.$Message.info(
                key.name +
                  vm.$t("common.customized") +
                  vm.$t("common.amountCannotMax") +
                  key.operator_recharge.amount_max
              );
              return;
            }
          }
        }
        money += key.phones.length * Number(key.amount);
      }
      params.type = vm.rechargeType == 0 ? 20 : 21;
      params.payment_id = vm.curPay.payment_id; //支付方式
      params.totalMoney = money.toFixed(2);
      if (vm.taskTimingFlag) {
        params.params = JSON.stringify(list);
        params.day = vm.thisDay;
        params.state = vm.switchFlag ? 1 : 0;
        if (vm.taskInfo.timer_id) {
          // 编辑任务
          params.timer_id = vm.taskInfo.timer_id;
        }
      } else {
        params.batch = JSON.stringify(list);
      }
      vm.$emit("getParams", params);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.global-dl {
  border-top: 1px solid #cccccc;
  padding: 20px 0;
  &:first-child {
    padding-top: 0;
    border-top: 0;
  }
  dl {
    dd {
      display: flex;
      overflow: hidden;
    }
  }
}
.recharge-title {
  dd {
    font-size: 16px;
    line-height: 32px;
  }
}
.recharge-num {
  margin-right: 15px;
  height: 200px;
  border-radius: 5px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 14px;
  padding: 8px 16px;
  line-height: 24px;
  overflow-y: auto;
  width: 280px;
}
.recharge-tab {
  flex: 1;
  overflow: hidden;
  /deep/.money-list ul {
    justify-content: space-between;
    max-height: 128px;
    &.moreMoney {
      max-height: initial;
    }
    li {
      margin-right: 0;
      width: calc(33.33% - 8px);
    }
  }
  .choose-combo {
    width: 100%;
    height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    padding: 4px 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    /deep/.ivu-icon {
      color: #dcdee2;
    }
    .info {
      width: 100%;
      color: #4a4a4a;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      &.default {
        color: #dcdee2;
      }
      p {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
